import { atomWithStorage } from "jotai/utils";

export const consentAtom = atomWithStorage(
  "consent",
  undefined as boolean | undefined,
);
consentAtom.debugLabel = "Consent Atom";
